
import React from 'react';
import { LogOut } from 'lucide-react';

interface SidebarFooterProps {
  isCollapsed: boolean;
  isMobileMenuOpen: boolean;
  onLogout: () => void;
}

export function SidebarFooter({ isCollapsed, isMobileMenuOpen, onLogout }: SidebarFooterProps) {
  return (
    <div className="p-4 border-t border-gray-100">
      <button
        onClick={onLogout}
        className={`flex items-center ${isMobileMenuOpen ? '' : isCollapsed ? 'justify-center' : ''} w-full px-4 py-2.5 rounded-xl text-gray-600 hover:bg-gray-50 transition-colors`}
        title="Sair"
      >
        <LogOut className="h-5 w-5 flex-shrink-0" style={{ marginRight: isMobileMenuOpen ? '0.75rem' : isCollapsed ? '0' : '0.75rem' }} />
        {(!isCollapsed || isMobileMenuOpen) && 'Sair'}
      </button>
    </div>
  );
}
